<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="signatory|@@signatory">Signataire</span>
      <svg id="checkmark-s" class="checkmark" width="16px" height="12px" viewBox="0 0 8 6" version="1.1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Enregistré</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="UI-Rapport-+-Slideshow-Current" transform="translate(-149.000000, -213.000000)" fill-rule="nonzero">
            <g id="Group" transform="translate(145.000000, 166.000000)">
              <g id="Group-9" transform="translate(0.000000, 35.000000)">
                <g id="Group-10">
                  <path
                    d="M10.8678734,12.1874017 L6.6639304,16.3885707 L5.13212661,14.8577776 C4.87000385,14.6047781 4.45334661,14.6083963 4.19566301,14.8659099 C3.93797941,15.1234234 3.93435877,15.5398058 4.1875254,15.8017555 L6.1916298,17.8045375 C6.45249729,18.0651542 6.87536351,18.0651542 7.136231,17.8045375 L11.8124746,13.1313796 C12.0656412,12.8694298 12.0620206,12.4530475 11.804337,12.1955339 C11.5466534,11.9380203 11.1299961,11.9344021 10.8678734,12.1874017 Z"
                    id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
  <div class="row report-form" style="margin-bottom: 200px;">
    <form [formGroup]="signatoryForm">
      <label><span i18n="signatory|@@lastName">Nom</span><input type="text" formControlName="lastName"
          placeholder="Devaigne"></label>
      <label><span i18n="signatory|@@firstName">Prénom</span><input type="text" formControlName="firstName"
          placeholder="Cyprien"></label>
      <label><span i18n="signatory|@@companyName"> Nom de l'entrerise</span><input type="text" formControlName="companyName"
           placeholder="Tchek"></label>
      <label><span i18n="signatory|@@signatoryLicense">Matricule entreprise</span><input type="text" formControlName="signatoryLicense"
              placeholder="746368656..."></label>
      <label><span i18n="signatory|@@email">Email</span><input type="email" formControlName="email"
          placeholder="cyprien@devaigne.com"></label>
      <label><span i18n="signatory|@@phone">Téléphone</span><input type="tel" formControlName="phone"
          placeholder="0712345678"></label>
      <p class="span-txt" i18n="signatory|@@signature">Signature</p>
      <div id="signature">
        <img *ngIf="drawNewSignature" src="{{report.signatorySignature.url()}}" alt=""
          style="width: 264px; height: 200px;">
        <signature-pad [ngClass]="{hidden: drawNewSignature}" [options]="signaturePadOptions"
          (onBeginEvent)="drawStart()" >
        </signature-pad>
        <button *ngIf="isdrawn || drawNewSignature" type="button" class="btn btn-lg secondary delButton" (click)="delSignature()">
          <span class="text-span" i18n="signatory|@@delete">Effacer</span>
        </button>
        <button *ngIf="isdrawn && !drawNewSignature" type="button" class="btn btn-lg valButton" (click)="drawComplete()">
          <span class="text-span buttonText" i18n="signatory|@@validate">Valider</span>
        </button>
      </div>

    </form>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/signatory/signatory.component.html